
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setApprovedCollab, setAverageRating, setBrandDetails, setCollabCount, setReviewCount, setReviewData } from 'states/brandDetails/brandDetailsSlice';
import { getAllCampaignsForCreator, getReviewsForBrand, getSingleBrand } from 'api/brandDetailsApi';


// Action to get all campaigns for the creator
export const getAllCampaignsForCreatorCall = createAsyncThunk(
  "campaigns/getCampaigns",
  async ({ token, page, data }, { rejectWithValue }) => {
    try {
      const response = await getAllCampaignsForCreator(token, page, data); // Call the API function
      return response.data; // Return the data from the response
    } catch (error) {
      // Handle error
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error); // Return the error if no response data
      }
    }
  }
);

// Action to get a single brand's details
export const getSingleBrandCall = createAsyncThunk(
  "brandDetails/getSingleBrand",
  async ({ token, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await getSingleBrand(token, data); // Call the API function
      dispatch(setBrandDetails(response?.data?.data)); // Dispatch to update brand details in Redux
      return response; // Return the response for further handling
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data); // Reject with error data
      } else {
        return rejectWithValue(error); // Reject with the error itself
      }
    }
  }
);

// Action to get reviews for a brand
export const getReviews = createAsyncThunk(
  "reviews/getReviews",
  async ({ token, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await getReviewsForBrand(token, data); // Call the API function
      dispatch(setApprovedCollab(response?.data?.data.active_collaborations)); // Dispatch approved collaborations
      dispatch(setCollabCount(response?.data?.data.approved_collaborations_count)); // Dispatch the count of collaborations
      dispatch(setReviewData(response?.data?.data.reviews)); // Dispatch reviews data
      dispatch(setAverageRating(response?.data?.data.average_rating)); // Dispatch average rating
      dispatch(setReviewCount(response?.data?.data.review_count)); // Dispatch review count
      return response; // Return the response for further handling
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data); // Reject with error data
      } else {
        return rejectWithValue(error); // Reject with the error itself
      }
    }
  }
);
